import cn from 'classnames';
import styles from './ViewControls.module.scss';
import { PageViewType } from '@/types';

type ViewControlsProps = {
  className?: string;
  view: PageViewType;
  onClick: (view: PageViewType) => void;
};

export function ViewControls({ className, view, onClick }: ViewControlsProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  const handleClick = (view: PageViewType) => {
    onClick(view);
  };

  if (view === PageViewType.Grid) {
    return (
      <img
        src="/svg/grid.svg"
        alt="view"
        className={wrapperClassName}
        onClick={() => handleClick(PageViewType.List)}
      />
    );
  }

  return (
    <img
      src="/svg/list.svg"
      alt="view"
      className={wrapperClassName}
      onClick={() => handleClick(PageViewType.Grid)}
    />
  );
}
